import { berRatings } from '../helper/lists';
import { FieldsCollection } from './FieldsCollection';

export class CalculatorFieldsCollection extends FieldsCollection {
    constructor() {
        super();
        this.addCurrencyField("homeValue", "Approximate Home Value", 0, 100000000);
        this.addCurrencyField("mortgageBalance", "Outstanding Mortgage Balance", 0, 100000000);
        this.addTextField("mortgageTerm", "Remaining Mortgage Term");
        this.addPicklistField("berRating", "BER Energy Rating", berRatings);
        this.addBooleanField("cashbackOnly", "Cashback Options Only");
    }
}